import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { change, formValueSelector } from 'redux-form';
import UserAddDialog from './user-add-dialog.presentation';
import {
  downloadAllVendorAsync,
  uploadNewUserAsync,
  downloadAllProfilesAsync,
  showErrorSnackbar,
  setMasterUserAddDialogStatus,
} from '../../redux/action';
import {
  ROLE_ADMIN,
  RXFORM_MASTER_USER_ADD,
  RXFIELD_MASTER_USER_COMPANY_ID,
  ROLE_CUSTOMER,
  RXFIELD_MASTER_USER_IS_ADMIN,
  ROLE_BILLING,
  DEFAULT_COMPANY,
  RXFIELD_MASTER_USER_IS_CORPORATE_ADMIN,
} from '../../constant';
import LocalizedString from '../../localization';
import { unauthorizedErrorHandler } from '../../helper';

const getVendorList = ({ currentUser, vendors }) => {
  if (currentUser.role === ROLE_ADMIN) {
    return _.values(vendors)
      .sort((left, right) => {
        if (left.name.trim().toLowerCase() > right.name.trim().toLowerCase()) {
          return 1;
        }
        if (left.name.trim().toLowerCase() < right.name.trim().toLowerCase()) {
          return -1;
        }
        return 0;
      })
      .map(vendor => ({ label: `${vendor.id} - ${vendor.name}`, value: vendor.id }));
  }
  return [{
    value: currentUser.company.id,
    label: currentUser.company.name,
  }];
};

const USER_ROLES = [ROLE_ADMIN, ROLE_CUSTOMER, ROLE_BILLING];

const mapStateToProps = state => ({
  initialValues: {
    [RXFIELD_MASTER_USER_IS_ADMIN]: ROLE_CUSTOMER,
  },
  currentUserRole: state.currentUser.role,
  loading: state.uiMasterUser.uploading || state.uiMasterVendor.downloadingVendors,
  vendors: getVendorList(state),
  selectedCompany: formValueSelector(RXFORM_MASTER_USER_ADD)(state, RXFIELD_MASTER_USER_COMPANY_ID),
  chbIsAdmin: formValueSelector(RXFORM_MASTER_USER_ADD)(state, RXFIELD_MASTER_USER_IS_ADMIN),
  lstUserRole: USER_ROLES.map(item => ({ label: item, value: item })),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: async (currentUserRole) => {
    if (currentUserRole === ROLE_ADMIN) {
      try {
        await dispatch(downloadAllVendorAsync());
      } catch (error) {
        dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      }
    }
  },
  onSubmitPressed: async (values) => {
    try {
      // add ROLE
      const role = values[RXFIELD_MASTER_USER_IS_ADMIN];
      const companyId = role !== ROLE_CUSTOMER ? DEFAULT_COMPANY : values.companyId;
      const formValues = {
        ...values,
        role,
        companyId,
      };
      await dispatch(uploadNewUserAsync(formValues));
      await dispatch(downloadAllProfilesAsync());
      dispatch(setMasterUserAddDialogStatus(false));
    } catch (error) {
      // show some error
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
  onUserRoleChaged: (value) => {
    if (value === ROLE_ADMIN) {
      dispatch(change(RXFORM_MASTER_USER_ADD, RXFIELD_MASTER_USER_IS_CORPORATE_ADMIN, false));
    }
  },
  onCompanySelected: (selectedCompany) => {
    // if (selectedCompany === 'CDP') {
    //   dispatch(change(RXFORM_MASTER_USER_ADD, RXFIELD_MASTER_USER_IS_CORPORATE_ADMIN, true));
    // } else {
    //   // dispatch(change(RXFORM_MASTER_USER_ADD, RXFIELD_MASTER_USER_IS_CORPORATE_ADMIN, false));
    // }
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserAddDialog));
